export default "__VITE_PUBLIC_ASSET__feb731c3__"